import script from "./PlanSendStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanSendStatus.vue?vue&type=script&setup=true&lang=js"

import "./PlanSendStatus.vue?vue&type=style&index=0&id=3d24e7ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d24e7ce"]])

export default __exports__